import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/model/user';
import { Company } from 'src/app/model/company';
import { Constants } from "../../../utils/constants";
import { UsersService } from 'src/app/services/users.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import {Tester} from "../../../model/tester";
import {Customer} from "../../../model/customer";

@Component({
  selector: 'aw-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

  loggedUser: User = this.authService.loggedUser();
  company?: Company;
  roles = Constants.roles;
  notifications: any[] = [];

  constructor(
    private authService: AuthService,
    private snackbar: MatSnackBar,
    private usersService: UsersService
  ) {
    if (this.loggedUser.role === this.roles.customer)
      this.company = (this.authService.loggedUser() as Customer)?.company;
  }

  ngOnInit() {
    this.usersService.getNotificationPreferences(this.loggedUser.id).subscribe(response => {
      let res = response as any;
      this.notifications = res.data;
    });

  }

  updateNotificationsOption(type: number, channel: number) {

    this.notifications[type].channels[channel].enabled = !this.notifications[type].channels[channel].enabled


  }

  saveNotificationsSettings() {
    this.usersService.markNotificationPreferences(this.loggedUser.id, this.notifications).subscribe(response => {
      this.snackbar.open('Notification preferences saved successfully', 'Undo', {
        duration: 2000
      });
    },
    error => {
      this.snackbar.open('Notification preferences not saved successfully', 'Undo', {
        duration: 2000
      });

    });

  }

}
